"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFile = void 0;
const AvatarSelector_1 = __importDefault(require("./components/AvatarSelector"));
const read_file_1 = __importDefault(require("./functions/read-file"));
exports.readFile = read_file_1.default;
exports.default = AvatarSelector_1.default;
